/* src/app/modules/shared/components/time-span-input/time-span-input.component.scss */
tel-input-container {
  display: flex;
}
.tel-input-element {
  border: none;
  background: none;
  padding: 0;
  max-width: 33%;
  outline: none;
  font: inherit;
  text-align: center;
}
input[type=number]::-webkit-outer-spin-button,
input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type=number] {
  -moz-appearance: textfield;
}
/*# sourceMappingURL=time-span-input.component.css.map */
